module.exports = __webpack_public_path__ + "assets/images/61fc45d0df95d26505088177f396c7fd.png";